import { render, staticRenderFns } from "./_SignInRule.vue?vue&type=template&id=2f90cc44&scoped=true"
import script from "./_SignInRule.vue?vue&type=script&lang=ts&scoped=true"
export * from "./_SignInRule.vue?vue&type=script&lang=ts&scoped=true"
import style0 from "./_SignInRule.vue?vue&type=style&index=0&id=2f90cc44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f90cc44",
  null
  
)

export default component.exports